import logo from "../../assets/logo/fetchjobLogo.png";
import { Link } from 'react-router-dom';
import classes from './styles/searchNavbarCircular.module.css';
import { useState } from "react";
const hemburgerIcon = "https://cdn-icons-png.flaticon.com/128/12314/12314153.png"

const Navbar = () => {
    const [mobileMenu, setMobileMenu] = useState(false);

  return (
      <>
        <div className={classes.container}>
        <div className={classes.innerContainer}>
          <Link to="/">
            <div className={classes.logoCon}>
              <img src={logo} alt="logo" />
            </div>
          </Link>

          {/* Desktop menu */}
          <div className={classes.buttonsCon}>
            <Link to="/" className={classes.button}>Home</Link>
            <Link to="/about" className={classes.button}>About</Link>
            <Link to="/contact" className={classes.button}>Contact</Link>
            <Link to="/career" className={classes.button}>Career</Link>
            <Link to="/blog" className={classes.button}>Blog</Link>

          </div>

          {/* Hamburger icon (mobile) */}
          <div
            className={classes.hamburger}
            onClick={() => setMobileMenu(!mobileMenu)}
          >
            <img src={hemburgerIcon} alt="menu" />
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenu && (
        <div className={classes.mobileMenu}>
          <Link onClick={() => setMobileMenu(false)} to="/">Home</Link>
          <Link onClick={() => setMobileMenu(false)} to="/about">About</Link>
          <Link onClick={() => setMobileMenu(false)} to="/contact">Contact</Link>
          <Link onClick={() => setMobileMenu(false)} to="/career">Career</Link>
          <Link onClick={() => setMobileMenu(false)} to="/blog">Blog</Link>
        </div>
      )}
        </>
  )
}

export default Navbar;
